import { render, staticRenderFns } from "./manureLeft3.vue?vue&type=template&id=5a46635f&scoped=true&"
import script from "./manureLeft3.vue?vue&type=script&lang=js&"
export * from "./manureLeft3.vue?vue&type=script&lang=js&"
import style0 from "./manureLeft3.vue?vue&type=style&index=0&id=5a46635f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a46635f",
  null
  
)

export default component.exports